import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import PharmaProcessFlow from "./PharmaProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  PHARMA_DOMAIN_INTRO,
  PHARMA_GROUPS,
  PHARMA_USE_CASES_SEO,
  PHARMA_DOMAIN_FAQS,
  PHARMA_ITEM_LIST_JSONLD,
  PHARMA_BREADCRUMB_JSONLD,
  PHARMA_WEBPAGE_JSONLD,
  PHARMA_FAQ_JSONLD,
} from "../../data/pharmaUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<PharmaProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = PHARMA_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function PharmaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? PHARMA_GROUPS : PHARMA_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={PHARMA_DOMAIN_INTRO}
        domainSlug="pharma-domain"
        useCaseCount={PHARMA_USE_CASES_SEO.length}
        groupCount={PHARMA_GROUPS.length}
        itemListJsonLd={PHARMA_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={PHARMA_BREADCRUMB_JSONLD}
        faqJsonLd={PHARMA_FAQ_JSONLD}
        webPageJsonLd={PHARMA_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{PHARMA_DOMAIN_INTRO.title}</h1>
          {PHARMA_DOMAIN_INTRO.content ? <p>{PHARMA_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={PHARMA_USE_CASES_SEO} groups={PHARMA_GROUPS} heading="Pharma Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>

      <DomainHiddenSeoContent
        domainTitle={PHARMA_DOMAIN_INTRO.title}
        domainFaqs={PHARMA_DOMAIN_FAQS}
        useCases={PHARMA_USE_CASES_SEO}
      />
    </div>
  );
}

